export default __webpack_public_path__ + "static/media/background.f776beb7.png";